var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{staticClass:"mt-6",attrs:{"title":"Has Managing Broker Approved?","no_border":true}},[_c('input-radio-boolean',{attrs:{"name":"purchase_side_broker_approved","value":_vm.commission_detail.purchase_side_broker_approved,"true":"Yes","false":"No","read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }